﻿import '../css/home.page.css';

import $ from 'jquery';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
Exporting(Highcharts);
import Map from 'highcharts/modules/map';
Map(Highcharts);
import usMap from '@highcharts/map-collection/countries/us/us-all.geo.json';
import { appConstants } from './app-constants';
import { configureCharts } from './chart-config';
import { showLoadingSpinner, hideLoadingSpinner } from './loading';
import { getAnalytics, logEvent } from "firebase/analytics";

const mapType = {
    rate: 1,
    perCapita: 2
};

class HomePage {

    filters = {
        state: 0,
        vaccine: 0,
        ageGroup: 0,
        gender: 0,
        ethnicity: 0,
        timePeriod: 0,
        timePeriod2: 0, //comparison timeperiod
        map: 0
    }

    viewModel = null;

    mapData = [];

    constructor() {
        // View model is initialized on script for page
        this.viewModel = viewModel;
        this.init();
    }

    init() {
        configureCharts(Highcharts);
        this.populateFilterState();
        this.setDefaultFilters();
        this.toggleTotalsCardVisibility();
        this.populateFilters();
        this.populateAgeFilter();
        this.addFilterChangeHandlers();
        this.populateVaccineInfo();
        this.addResetMapHandler();
        this.populateSidePanelTooltips();
    }

    populateSidePanelTooltips(statename) {
        const state = statename ? statename : 'the U.S.';

        const ageText = appConstants.tooltipByAge.replace('the U.S.', state);
        $('#byAgeTooltip').html(ageText);
        const genderText = appConstants.tooltipByGender.replace('the U.S.', state);
        $('#byGenderTooltip').html(genderText);
        const ethnicityText = appConstants.tooltipByEthnicity.replace('the U.S.', state);
        $('#byEthnicityTooltip').html(ethnicityText);
        const totalText = appConstants.tooltipTotalVaccinated.replace('the U.S.', state);
        $('#totalVaccinatedTooltip').html(totalText);
        const gapText = appConstants.tooltipGapAnalysis.replace('the U.S.', state);
        $('#gapAnalysisTooltip').html(gapText);
    }

    setDefaultFilters() {
        if (!this.filters.state) {
            this.filters.state = appConstants.national;
        }
        if (!this.filters.ageGroup) {
                this.filters.ageGroup = appConstants.ageGroup;
        }
        if (!this.filters.vaccine) {
            this.filters.vaccine = appConstants.influenza;
            $('#vaccineFilter').val(this.filters.vaccine);
        }
        if (!this.filters.timePeriod2) {
            this.filters.timePeriod2 = appConstants.timePeriod2;
        }
        if (!this.filters.timePeriod) {
            this.filters.timePeriod = appConstants.timePeriod;
            $('#timePeriodFilter').val(this.filters.timePeriod);
        }
        if (!this.filters.map) {
            this.filters.map = mapType.rate;
        }
    }

    populateFilters() {
        const keys = Object.keys(this.filters);
        keys.forEach(key => {
            const selector = `#${key}Filter`;
            if (this.filters[key]) {
                $(selector).val(this.filters[key]);
            }
        });
    }

    populateAgeFilter() {
        const url = `${appConstants.ageListUrl}?value=${this.filters.vaccine}`;
        $.getJSON(url, results => {
            let html = ''; //<option value="0">All Age Groups</option>'; //disable all age groups for now
            results.forEach(result => {
                html += `<option value="${result.ageGroupId}">${result.ageGroup}</option>`;
            });
            $('#ageGroupFilter').html(html);

            // If the selected ageGroup does not exist in the list then select first item in age group list
            if (!results.find(x => x.ageGroupId === this.filters.ageGroup)) {
                this.filters.ageGroup = results[0].ageGroupId;
            }

            $('#ageGroupFilter').val(this.filters.ageGroup);
            this.getMapData();
            this.populateCharts();
            this.updateDetailsLinks();
        });
    }

    addFilterChangeHandlers() {
        const keys = Object.keys(this.filters);
        keys.forEach(key => {
            const selector = `#${key}Filter`;
            $(selector).on('change', e => {
                const value = e.currentTarget.value;
                this.handleFilterSelect(key, value);
                // log new event
                const id = $(selector).find(`option[value="${value}"]`).text();
                this.logFilterChangeEvent(key, id);
            });
        });
    }

    addResetMapHandler() {
        $('#mapResetButton').on('click', () => {
            this.updateState(null, appConstants.national);
            this.populateMap();
        });
    }

    handleFilterSelect(key, value) {
        this.filters[key] = parseInt(value);

        const url = new URL(window.location.href);
        url.searchParams.set(key, value);
        window.history.replaceState(null, null, url);

        if (key === 'vaccine') {
            this.filters.ageGroup = appConstants.ageGroup; // Reset age group to 0 when vaccine filter changes
            url.searchParams.set('ageGroup', appConstants.ageGroup);
            this.populateVaccineInfo();
            this.populateAgeFilter();
        } else {
            if (key !== 'map') {
                this.getMapData();
                this.populateCharts();
                this.updateDetailsLinks();
            } else {
                this.toggleTotalsCardVisibility();
                this.populateMap();
            }
        }
    }

    updateDetailsLinks() {
        const search = window.location.search;
        if (search) {
            $('a.details-link').each(function () {
                const href = $(this).attr('href');
                var base = href;
                if (href.indexOf('&') > 0) {
                    base = href.substr(0, href.indexOf('&')); // chop off previous url params
                }
                $(this).attr('href', `${base}${search.replace('?', '&')}`);
            });
        }
    }

    populateFilterState() {
        let filterParams = new URLSearchParams(window.location.search);
        filterParams.forEach((value, key) => {
            this.filters[key] = parseInt(value);
        });
    }

    generateFilterPayload() {
        return {
            yearId: this.filters.timePeriod,
            prevYearId: this.filters.timePeriod2,
            monthId: 0,
            vaccineId: this.filters.vaccine,
            stateId: this.filters.state,
            genderId: this.filters.gender,
            ageRangeId: 0,
            ageGroupId: this.filters.ageGroup,
            ethnicityId: this.filters.ethnicity,
            pointOfAccessId: 0,
            payTypeId: 0,
            projected: 0,
            month: 0
        }
    }

    populateVaccineInfo() {
        const vaccine = this.viewModel.vaccineList.find(s => s.value == this.filters.vaccine);
        var name = '';
        if (vaccine) {
            if (vaccine.text.toLowerCase() == 'total (excluding influenza)') {
                name = 'Total (excluding Influenza & RSV)';
            } else {
                name = vaccine.text;
            }

            $('#vaccineName').html(name);

            const vaccineDescription = this.viewModel.vaccineDescriptionList.find(s => s.value == vaccine.text);
            if (vaccineDescription) {
                $('#vaccineDetails').html(vaccineDescription.text);
            }
            const cdclink = this.viewModel.vaccineCDCLink.find(s => s.value == vaccine.text);
            if (cdclink) {
                $('#cdcLink').prop("href", cdclink.text);
            }
        }
    }

    populateCharts() {
        this.populateGAPChart();
        this.populateByAgeChart();
        this.populateByGenderChart();
        this.populateByEthnicityChart();
    }

    populateGAPChart() {
        const url = `/api/TrendsCharts/Totals`;
        showLoadingSpinner('#GAPChart');
        $.ajax(url, {
            data: JSON.stringify(this.generateFilterPayload()),
            contentType: 'application/json',
            type: 'POST'
        }).done(data => {
            hideLoadingSpinner('#GAPChart');
            const chartOptions = {
                chart: {
                    width: null,
                    height: 200
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: data.map(d => appConstants.monthLabels[d.month - 1]),
                    labels: {
                        step: 2
                    }
                },
                yAxis: {
                    title: '',
                    type: 'logarithmic',
                    custom: {
                        allowNegativeLog: true
                    }
                },
                series: [{
                    type: 'column',
                    name: `${this.filters.timePeriod} - ${this.filters.timePeriod2} Difference`,
                    negativeColor: '#544F40',
                    data: data.map(d => {
                        return {
                            name: appConstants.monthLabels[d.month - 1],
                            y: d.diffProjected
                        }
                    })
                }]
            };
            Highcharts.chart('GAPChart', chartOptions);
        });
    }

    populateByAgeChart() {
        const url = `/api/Charts/getbyage`;
        showLoadingSpinner('#ageChart');
        $.ajax(url, {
            data: JSON.stringify(this.generateFilterPayload()),
            contentType: 'application/json',
            type: 'POST'
        }).done(data => {
            hideLoadingSpinner('#ageChart');
            const chartOptions = {
                chart: {
                    width: null,
                    height: 200
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: data.map(d => d.ageGroup)
                },
                yAxis: {
                    title: '',
                    endOnTick: false,
                    type: 'logarithmic',
                    custom: {
                        allowNegativeLog: false
                    }
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    pointFormat: '{series.name}<b>{point.custom.extraInformation}</b>'
                },
                series: [{
                    type: 'column',
                    name: 'Projected Value',
                    data: data.map(d => {
                        return {
                            name: d.ageGroup,
                            y: (d.projectedValue < 10) ? 10 : d.projectedValue,
                            custom: {
                                extraInformation: (d.projectedValue < 10) ? ' < 10' : ': ' + d.projectedValue.toLocaleString('en-US')
                            }
                        }
                    })
                }]
            };
            Highcharts.chart('ageChart', chartOptions);
        });
    }

    populateByGenderChart() {
        const url = `/api/Charts/getbygender`;
        showLoadingSpinner('#genderChart');
        $.ajax(url, {
            data: JSON.stringify(this.generateFilterPayload()),
            contentType: 'application/json',
            type: 'POST'
        }).done(data => {
            hideLoadingSpinner('#genderChart');
            const chartOptions = {
                chart: {
                    width: null,
                    height: 275
                },
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '{series.name}<b>{point.custom.extraInformation}</b>'
                },
                series: [{
                    type: 'pie',
                    name: 'Projected Value',
                    data: data.map(d => {
                        return {
                            name: d.gender,
                            y: (d.projectedValue < 10) ? 10 : d.projectedValue,
                            custom: {
                                extraInformation: (d.projectedValue < 10) ? ' < 10' : ': ' + d.projectedValue.toLocaleString('en-US')
                            }
                        };
                    })
                }]
            };
            Highcharts.chart('genderChart', chartOptions);
        });
    }

    populateByEthnicityChart() {
        const url = `/api/Charts/getbyethnicity`;
        showLoadingSpinner('#ethnicityChart');
        $.ajax(url, {
            data: JSON.stringify(this.generateFilterPayload()),
            contentType: 'application/json',
            type: 'POST'
        }).done(data => {
            hideLoadingSpinner('#ethnicityChart');
            const chartOptions = {
                chart: {
                    width: null,
                    height: 300
                },
                title: {
                    text: ''
                },
                plotOptions: {
                    pie: {
                        innerSize: '60%'
                    }
                },
                tooltip: {
                    pointFormat: '{series.name}<b>{point.custom.extraInformation}</b>'
                },
                series: [{
                    type: 'pie',
                    name: 'Projected Value',
                    data: data.map(d => {
                        return {
                            name: d.ethnicity,
                            y: (d.projectedValue < 10) ? 10 : d.projectedValue,
                            custom: {
                                extraInformation: (d.projectedValue < 10) ? ' < 10' : ': ' + d.projectedValue.toLocaleString('en-US')
                            }
                        };
                    })
                }]
            };
            Highcharts.chart('ethnicityChart', chartOptions);
        });
    }

    getMapData() {
        const url = `/api/Map/getmap`;
        showLoadingSpinner('#map', '5rem');
        showLoadingSpinner('#totalChart');
        $('#totalValue').empty();
        $('#mapResetButton').addClass('d-none');
        $.ajax(url, {
            data: JSON.stringify({ ...this.generateFilterPayload(), stateId: 0 }),
            contentType: 'application/json',
            type: 'POST'
        }).done(data => {
            hideLoadingSpinner('#map');
            hideLoadingSpinner('#totalChart');
            $('#mapResetButton').removeClass('d-none');
            this.mapData = data;
            this.populateTotals();
            this.populateMap();
        });
    }

    populateTotals() {
        const data = this.mapData;
        let totalVaccinated = 0;
        let totalPopulation = 0;
        
        const state = data.find(d => d.stateId === this.filters.state);
        if (state) {
            totalVaccinated = state.projectedValue;
            totalPopulation = state.population;
        }

        totalVaccinated = totalVaccinated < 10 ? '< 10' : totalVaccinated;
        $('#totalValue').html(totalVaccinated.toLocaleString('en-US'));

        const chartOptions = {
            chart: {
                height: 117,
                width: 117
            },
            title: {
                verticalAlign: 'middle',
                floating: true,
                text: totalPopulation !== 0 ? `${((totalVaccinated / totalPopulation) * 100).toFixed()}%` : '0%',
                style: {
                    fontSize: '24px'
                }
            },
            plotOptions: {
                pie: {
                    size: 112,
                    innerSize: '80%',
                    states: {
                        hover: {
                            enabled: false
                        },
                        inactive: {
                            opacity: 1
                        }
                    }
                }
            },
            tooltip: {
                outside: true
            },
            legend: {
                enabled: false
            },
            series: [{
                type: 'pie',
                name: 'Total',
                data: [{
                    name: 'Vaccinated',
                    y: totalVaccinated
                }, {
                    name: 'Unvaccinated',
                    color: '#F0EFED',
                    y: totalPopulation - totalVaccinated
                }]
            }]
        };
        Highcharts.chart('totalChart', chartOptions);
    }

    toggleTotalsCardVisibility() {
        if (this.filters.map === mapType.rate) {
            $('#totalsVaxPanel').hide();
            $('#vaccineDetailsPanel').removeClass('col-md-6').addClass('col-md-12');
        } else {
            $('#totalsVaxPanel').show();
            $('#vaccineDetailsPanel').removeClass('col-md-12').addClass('col-md-6');
        }
    }

    populateMap() {
        var that = this;
        const data = this.mapData;
        const timePeriod = this.filters.timePeriod;

        // Common map options
        let mapOptions = {
            chart: {
                map: usMap,
                marginTop: 100,
            },
            title: {
                text: ''
            },
            legend: {
                verticalAlign: 'bottom'
            },
            exporting: {
                enabled: true,
                buttons: {
                    contextButton: {
                        y: 10,
                        x: -10
                    }
                }
            },
            colorAxis: {
                labels: {
                    overflow: 'allow'
                }
            },
            mapNavigation: {
                enabled: true,
                buttonOptions: {
                    padding: 10,
                    width: 20,
                    height: 30,
                    x: -10,
                    // y: -40,
                    theme: { fill: 'white', r: 18, 'stroke': '#ADA7A3' },
                    verticalAlign: 'bottom',
                    align: 'right',
                    alignTo: 'spacingBox'
                },
                buttons: {
                    zoomIn: {
                        y: -40
                    },
                    zoomOut: {
                        y: 10
                    }
                }
            },
            tooltip: {
                backgroundColor: '#FFF',
                useHTML: true,
                outside: true
            },
            series: [{
                joinBy: ['hc-key', 'code'],
                borderColor: '#FFFFFF',
                dataLabels: {
                    enabled: false
                },
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
                            this.select();
                            const stateName = this.name;
                            const state = data.find(d => d.state.toLowerCase() === stateName.toLowerCase());
                            if (state) {
                                that.logFilterChangeEvent('state', state.state);
                                that.updateState(state.state, state.stateId);
                            }
                        },
                        unselect: function () {
                            return false;
                        }
                    }
                }
            }]
        }

        // Map type specific options
        switch (this.filters.map) {
            case mapType.perCapita:
                // get data range w\o outliers
                const max = data.sort((a, b) => b.percapita - a.percapita)[2];
                const min = data[data.length - 2];
                $('#mapDesc').html(appConstants.mapPerCapitaDesc);
                mapOptions = {
                    ...mapOptions,
                    colorAxis: {
                        ...mapOptions.colorAxis,
                        min: min.percapita,
                        max: max.percapita,
                        stops: [
                            [0, '#0B3C49'],
                            [0.2, '#0F5264'],
                            [0.4, '#147189'],
                            [0.6, '#1B96B6'],
                            [0.8, '#23C8F3'],
                            [1.0, '#ABEEFF']
                        ]
                    },
                    tooltip: {
                        ...mapOptions.tooltip,
                        formatter: function () {
                            return `
                                <h2 class="map-tooltip-header">${this.point.name}</h2>
                                <div class="map-tooltip-value">
                                    ${this.point.value.toLocaleString('en-US', { maximumFractionDigits: 0 })}
                                </div>
                                vaccinated per 100k population
                            `;
                        }
                    },
                    series: [{
                        ...mapOptions.series[0],
                        states: {
                            select: {
                                color: '#DFF4F8'
                            }
                        },
                        data: data.map(d => {
                            const code = this.getStateCode(d.state);
                            return {
                                code: code,
                                id: code,
                                name: d.state,
                                value: d.percapita
                            }
                        })
                    }]
                }
                break;
            case mapType.rate:
                const maxPct = 10 * Math.round(data.sort((a, b) => b.percentChange - a.percentChange)[2].percentChange / 10.0);
                const minPct = 10 * Math.round(data[data.length - 2].percentChange / 10.0);
                $('#mapDesc').html(appConstants.mapDefaultDesc);
                //console.log('min: ' + minPct + ', max: ' + maxPct);
                mapOptions = {
                    ...mapOptions,
                    colorAxis: {
                        ...mapOptions.colorAxis,
                        min: minPct,
                        max: maxPct,
                        stops: [
                            [0, '#612914'], //743118
                            [0.25, '#aa4724'], //C04727
                            [0.5, '#F36633'], //F36633
                            [0.8, '#f79470'], //E0AA8F
                            [1, '#fac2ad'] //EDD0C0
                        ],
                        labels: {
                            ...mapOptions.colorAxis.labels,
                            formatter: function () {
                                return `${this.value}%`;
                            }
                        }
                    },
                    tooltip: {
                        ...mapOptions.tooltip,
                        formatter: function () {
                            var direction = this.point.value < 0 ? 'decrease' : 'increase';
                            return `
                                <h2 class="map-tooltip-header">${this.point.name}</h2>
                                <div class="map-tooltip-value">
                                    ${this.point.value.toLocaleString('en-US', { maximumFractionDigits: 0 })}%
                                </div>
                               <span class="map-tooltip-message">
                                   ${direction} from ${this.point.previousYearProjected.toLocaleString('en-US')} in 2019 
                                    to ${this.point.projectedValue.toLocaleString('en-US')} in ${timePeriod}
                               </span>    
                            `;
                        }
                    },
                    series: [{
                        ...mapOptions.series[0],
                        states: {
                            select: {
                                color: '#F8EAE8'
                            }
                        },
                        data: data.map(d => {
                            const code = this.getStateCode(d.state);
                            return {
                                code: code,
                                id: code,
                                name: d.state,
                                value: d.percentChange,
                                projectedValue: d.projectedValue,
                                previousYearProjected: d.previousYearProjected
                            }
                        })
                    }]
                }
                break;
        }

        // Render the map
        const chart = Highcharts.mapChart('map', mapOptions);

        //Load selected state, if any
        if (this.filters.state !== 0) {
            const state = data.find(d => d.stateId === this.filters.state);
            if (state) {
                this.updateStateLabel(state.state);
                const stateCode = this.getStateCode(state.state);
                const element = chart.get(stateCode);
                if (element) {
                    element.select();
                }
            }
        }
    }

    logFilterChangeEvent(filterId, id) {
        const analytics = getAnalytics();
        logEvent(analytics, 'select_content', {
            content_type: filterId,
            item_id: id
        });
    }

    updateState(state, id) {
        if (this.filters.state !== id) {
            this.filters.state = id;

            const url = new URL(window.location.href);
            if (this.filters.state !== 0) {
                url.searchParams.set('state', id);
            } else {
                url.searchParams.delete('state');
            }
            window.history.replaceState(null, null, url);

            this.updateStateLabel(state);
            this.updateDetailsLinks();
            this.populateCharts();
            this.populateTotals();
        }
    }

    updateStateLabel(state) {
        const label = state ? state : 'U.S.';
        $('#gapStateLabel').html(label);
        $('#ageStateLabel').html(label);
        $('#genderStateLabel').html(label);
        $('#ethnicityStateLabel').html(label);

        this.populateSidePanelTooltips(label);
    }

    getStateCode(state) {
        const stateList = {
            'Arizona': 'AZ',
            'Alabama': 'AL',
            'Alaska': 'AK',
            'Arkansas': 'AR',
            'California': 'CA',
            'Colorado': 'CO',
            'Connecticut': 'CT',
            'District of Columbia': 'DC',
            'Delaware': 'DE',
            'Florida': 'FL',
            'Georgia': 'GA',
            'Hawaii': 'HI',
            'Idaho': 'ID',
            'Illinois': 'IL',
            'Indiana': 'IN',
            'Iowa': 'IA',
            'Kansas': 'KS',
            'Kentucky': 'KY',
            'Louisiana': 'LA',
            'Maine': 'ME',
            'Maryland': 'MD',
            'Massachusetts': 'MA',
            'Michigan': 'MI',
            'Minnesota': 'MN',
            'Mississippi': 'MS',
            'Missouri': 'MO',
            'Montana': 'MT',
            'Nebraska': 'NE',
            'Nevada': 'NV',
            'New Hampshire': 'NH',
            'New Jersey': 'NJ',
            'New Mexico': 'NM',
            'New York': 'NY',
            'North Carolina': 'NC',
            'North Dakota': 'ND',
            'Ohio': 'OH',
            'Oklahoma': 'OK',
            'Oregon': 'OR',
            'Pennsylvania': 'PA',
            'Rhode Island': 'RI',
            'South Carolina': 'SC',
            'South Dakota': 'SD',
            'Tennessee': 'TN',
            'Texas': 'TX',
            'Utah': 'UT',
            'Vermont': 'VT',
            'Virginia': 'VA',
            'Washington': 'WA',
            'West Virginia': 'WV',
            'Wisconsin': 'WI',
            'Wyoming': 'WY'
        }

        const code = stateList[state];
        if (code) {
            return `us-${code.toLowerCase()}`;
        } else {
            return ''
        }
    }
}

$(() => {
    $('#mainContentLoading').addClass('d-none');
    $('#mainContent').removeClass('d-none');
    new HomePage();
})